export default __webpack_public_path__ + "static/media/AddImageIcon.036172a6.svg";